import React from 'react';
import PropTypes from 'prop-types';

const IconArrowLeft = ({ fill, className, width, height }) => (
    <svg
        className={`apc-svg-icon ${className}`}
        viewBox="0 0 50 50"
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M35.014 10.39L22.129 25l12.885 14.61c1.315 1.232 1.315 3.232 0 4.465-1.315 1.233-3.447 1.233-4.762 0L14.986 27.233c-1.315-1.233-1.315-3.233 0-4.466L30.252 5.925c1.315-1.233 3.447-1.233 4.762 0 1.315 1.233 1.315 3.233 0 4.466z"
            fill={fill}
            fillRule="nonzero"
        />
    </svg>
);

IconArrowLeft.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconArrowLeft.defaultProps = {
    fill: '#9FA0A4',
    className: '',
    width: 20,
    height: 20,
};

export default IconArrowLeft;
